export const nero={
    50: "#000000",
    100: "#000000",
    150: "#020202",
    200: "#040404",
    250: "#080808",
    300: "#0D0D0D",
    350: "#131313",
    400: "#191919",
    450: "#1F1F1F",
    500: "#252525",
    550: "#373737",
    600: "#4B4B4B",
    650: "#5F5F5F",
    700: "#747474",
    750: "#8A8A8A",
    800: "#A0A0A0",
    850: "#B7B7B7",
    900: "#CECECE",
    950: "#E6E6E6",
    975: "#F4F7F7",
    990: "#FBFCFC",
  } as const;